import React from "react";
import { useDispatch } from "react-redux";
import './styles.scss'
import { openModal } from "@/reducers/modals";

const SignedOutIntroCTA = () => {
  const dispatch = useDispatch();

  const handleGetStarted = () => {
    window.history.pushState({}, "", `${window.location.pathname}?auth=login`);
    dispatch(openModal({ name: "loginModal", data: { show: true } }));
  };

  return (
    <div className="signed-out-intro-cta">
      <h3 className="signed-out-intro-cta__heading">
        Skip the Daily Scroll
      </h3>
      <p className="signed-out-intro-cta__body">
        Sign up to get alerted when a buyer is looking for a property like yours.
      </p>
      <button
        className="btn signed-out-intro-cta__btn"
        onClick={handleGetStarted}
      >
        Get Started
      </button>
      <p className="signed-out-intro-cta__footnote">
        No need to browse the feed 24/7.
      </p>
    </div>
  );
};

export default SignedOutIntroCTA;
